import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/react";
import { styled } from "../../../theme";
import { Icon } from "../../../icon";
import { FlexRow } from "../../../box";
import { LockIcon } from "../LockIcon";
export const PLACEHOLDER_OPTION_VALUE = "!_PLACEHOLDER_DISABLED_OPTION_VALUE_!";
export const Select = (props) => (_jsxs(Wrapper, { children: [props.disabled ? _jsx(SelectLockIcon, {}) : _jsx(StyledIcon, { name: "down" }), _jsx(StyledSelect, { isPlaceholder: props.value === PLACEHOLDER_OPTION_VALUE, disabled: props.disabled, "data-test-id": props.name, ...props })] }));
const Wrapper = styled(FlexRow) `
  width: 100%;
  box-sizing: border-box;
  cursor: default;
  display: flex;
  flex-direction: row;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  min-height: 35px;
  text-overflow: ellipsis;
`;
const StyledSelect = styled.select `
  appearance: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  width: inherit;
  outline: none;
  border: 0;
  background: transparent;

  font-size: 1.375em;
  font-family: Gilroy, sans-serif;
  padding: 0.75em 4px;
  color: ${({ theme }) => theme.color.darkBlue90};
  opacity: ${({ isPlaceholder }) => (isPlaceholder ? "0.75" : "1")};
  ${({ disabled }) => disabled &&
    css `
      opacity: 0.65;
      padding-right: 5em;
      cursor: not-allowed;
      filter: saturate(25%);
    `}
`;
const SelectLockIcon = styled(LockIcon) `
  position: absolute;
  right: 0;
`;
const StyledIcon = styled(Icon) `
  margin-right: 4px;
  margin-left: 4px;
  position: absolute;
  right: 0;
  font-size: 0.75em;
  color: ${({ theme }) => theme.color.primary};
  pointer-events: none;
`;
